import React from 'react';
import { Box } from '@mui/material';
import { MenuItem } from '@mui/material';
import { connect } from 'react-redux';
import { languageSet } from 'store/general';
import { backStepSet } from 'store/steps';
import { QFlowLogo, LanguageSelector, HeaderWrapper, LanguageWrapper, StyledFormControlLabel } from './styles'
import { useOnlineBookingLocale } from 'shell/OnlineBookingLocale';


const RandomVersion = Math.floor(Math.random() * 10000);
const Logo = (({ appTheme }) => {

  const {ThemeId, Logo, filesUrl} = appTheme ?? {};
  const { t } = useOnlineBookingLocale();

  return (
    <img
      src={`${filesUrl}/${ThemeId}/${Logo}?ver=${RandomVersion}`}
      onError={(event) => event.target.style.display = 'none'}
      alt={t('ariaLabel.logoImageAlt')}
    />
    )
});

 const Header = (({ languages, appTheme, lngCode, languageSet, theme,  children}) => {

  const MenuProps = { PaperProps :{ sx: {
    "&.MuiPaper-root": { [theme.breakpoints.down('sm')]: { marginLeft: '0.5em' },
    "& .MuiMenuItem-root": { justifyContent: 'center' } }
  } } }

  const moreThanOneLanguage = languages?.length > 1;

  return (
  <HeaderWrapper>
    {/* { hasBackButton && <NavigationBack onNavigateBack={backStepSet}/>} */}
    <QFlowLogo >
      <Logo {...{appTheme}} />
    </QFlowLogo>
    { children }

      <LanguageWrapper>
        { moreThanOneLanguage &&
          <StyledFormControlLabel
            control={
              <LanguageSelector
                inputProps={{'aria-label': 'Language' }}
                value={lngCode}
                fullWidth={false}
                title={lngCode}
                onChange={e => languageSet({lngCode: e.target.value})}
                SelectProps={{ MenuProps }}
              >
                {(languages || [])
                  .map((locale) => {
                    return <MenuItem key={locale} value={locale} title={locale}>{locale}</MenuItem>
                })}
              </LanguageSelector>
            }
          />
        }
     </LanguageWrapper>


  </HeaderWrapper>);
});

export default connect(
  ({ current: { steps: { activeStep, successStepActive}, general: { language: { lngCode } } } }) => ({ lngCode, activeStep, successStepActive}),
  { languageSet, backStepSet })
  (Header);